import {  visitRecordConstants } from "@constants";

const initalState = {
  reasonOptions: {
    loading: false,
    data: [],
    fail: null
  }
};

export const visitRecord = (state = initalState, action) => {
  switch (action.type) {
    case visitRecordConstants.GET_REASON_OPTIONS_REQUEST:
      return {
        ...state,
        reasonOptions: {
          loading: true,
          data: []
        }
      };
    case visitRecordConstants.GET_REASON_OPTIONS_SUCCESS:
      return {
        ...state,
        reasonOptions: {
          loading: false,
          data: action.reasonOptions
        }
      };
    case visitRecordConstants.GET_REASON_OPTIONS_FAILURE:
      return {
        ...state,
        reasonOptions: {
          loading: false,
          data: [],
          fail: action.error
        }
      };
    case visitRecordConstants.RESET_REASON_OPTIONS_SUCCESS:
      return {
        ...state,
        reasonOptions: initalState.reasonOptions
      };
    default:
      return state;
  }
};
